import { Map as ImmutableMap } from 'immutable';

import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import store from 'app-components/utils/redux-store';

import type { AiSummaryDialogProps } from './index';

export const AI_SUMMARY_DIALOG = 'AI_SUMMARY_DIALOG';

export const closeAiSummary = () => {
  store?.dispatch(rootUiActions.removeDialog(AI_SUMMARY_DIALOG));
};

const useAiSummaryDialog = () => {
  return (props: Omit<AiSummaryDialogProps, 'onClose'>) => {
    if (!store) return;

    const nextProps = ImmutableMap({ ...props, onClose: closeAiSummary });

    store.dispatch(rootUiActions.removeDialog(AI_SUMMARY_DIALOG));

    store.dispatch(
      rootUiActions.createDialog(
        rootUiTypes.mkRootUiData({
          id: AI_SUMMARY_DIALOG,
          type: AI_SUMMARY_DIALOG,
          props: nextProps,
        }),
      ),
    );
  };
};

export default useAiSummaryDialog;
